export const MIN_SWIPE_DISTANCE = 50;
